import {useContext} from 'react'
import {LiquidationReportPageContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import ProductReportsTableRow from './LiquidationReportTableRow'
import ProductReportOverlay from '../overlay/ProductReportOverlay'

const LiquidationReportTable = () => {
  const {LiquidationReportsData, isLoading, filters, onSortingChange, checkedRows, setCheckedRows} =
    useContext(LiquidationReportPageContext)

  const columns = [
    {key: '', headerStyle: 'min-w-40px w-40px', label: ''}, // Product mark
    {key: 'name', headerStyle: 'min-w-450px w-450px', label: 'Product Name', isSorted: true}, // Product Name
    {key: 'sku', headerStyle: 'min-w-150px w-150px', label: 'SKU', isSorted: true}, // SKU
    {
      key: 'calculated_price',
      headerStyle: 'min-w-150px w-150px',
      label: 'BC Price',
      isSorted: true,
      style: 'justify-content-center',
    }, // SKU
    {
      key: 'variant_count',
      headerStyle: 'min-w-175px w-175px',
      label: 'Variant Count',
      isSorted: true,
      style: 'justify-content-center',
    }, // Variant Count
    {
      key: 'inventory_level',
      headerStyle: 'min-w-175px w-175px',
      label: 'Inventory Packs',
      isSorted: true,
      style: 'justify-content-center',
    }, // Inventory Packs
    {
      key: 'total_blocked_qty',
      headerStyle: 'min-w-200px w-200px',
      label: 'Blocked Quantity',
      isSorted: true,
      style: 'justify-content-center',
    }, // Blocked Quantity

    {
      key: 'pack_count',
      headerStyle: 'min-w-150px w-150px',
      label: 'Pack Count',
      isSorted: true,
      style: 'justify-content-center',
    }, // Pack Count
    {
      key: 'piece_count',
      headerStyle: 'min-w-150px w-150px',
      label: 'Piece Count',
      isSorted: true,
      style: 'justify-content-center',
    }, // Piece Count
    {
      key: 'price_per_piece',
      headerStyle: 'min-w-120px w-120px',
      label: 'Price/PC',
      isSorted: true,
      style: 'justify-content-center',
    }, // Price/PC
    {
      key: 'action',
      label: 'Action',
      render: (row: any) => <ProductReportOverlay />, // Action Modal or Component
    },
  ]

  return (
    <DynamicTable
      id='product-report-table'
      data={LiquidationReportsData}
      filters={filters}
      sortableColumns={columns}
      onSortingChange={onSortingChange}
      loading={isLoading}
      TableRow={ProductReportsTableRow}
      checkedRowId={checkedRows}
      setCheckedRows={setCheckedRows}
      tableRowProps={{isChild: false}}
      tableClass='table table-row-bordered table-row-gray-300 align-middle gs-0 gy-3 mb-5 pb-5'
      permissionPath={'products_liquidation'}
    />
  )
}

export default LiquidationReportTable
